/**
 * @owner @Appboy/messaging-experience
 */
import { developerRemoteLookupValidators } from "../.generated/developerRemoteLookup";
import type { DeveloperRemoteLookupProvider } from "../.generated/developerRemoteLookup";

export const developerProvider: DeveloperRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => `${item.email} ${item.first_name} ${item.last_name}`,
  validators: developerRemoteLookupValidators,
};
